import { useEffect, useState } from "react";

export default function Countdown({ target, testid }) {
    const [diff, setDiff] = useState(() => new Date(target).getTime() - Date.now());
    useEffect(() => {
        setDiff(new Date(target).getTime() - Date.now());
        const t = setInterval(() => setDiff(new Date(target).getTime() - Date.now()), 1000);
        return () => clearInterval(t);
    }, [target]);
    if (!target || diff <= 0) return null;
    const parts = [
        { label: "Days", value: Math.floor(diff / 86400000) },
        { label: "Hrs", value: Math.floor((diff / 3600000) % 24) },
        { label: "Min", value: Math.floor((diff / 60000) % 60) },
        { label: "Sec", value: Math.floor((diff / 1000) % 60) },
    ];
    return (
        <div data-testid={testid} className="flex gap-2 sm:gap-3">
            {parts.map((p) => (
                <div
                    key={p.label}
                    className="bg-[#12121A]/90 border border-[#262638] rounded-xl px-3 sm:px-4 py-2 sm:py-3 text-center min-w-[64px] backdrop-blur-md"
                >
                    <div className="font-stat font-bold text-2xl sm:text-3xl text-[#FF5500] animate-score-flicker">
                        {String(p.value).padStart(2, "0")}
                    </div>
                    <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 font-semibold">{p.label}</div>
                </div>
            ))}
        </div>
    );
}
